export const projects = [
  {
    img: "https://cdn.jsdelivr.net/gh/svskaushik/svskaushik@main/Assets/pizzawallet.JPG",
    name: "Pizza Wallet",
    ext: "jsx/sol",
    lang: "js,solidity",
    git: "https://github.com/svskaushik/Pizza-Wallet",
    live: "https://pizza-wallet.vercel.app/",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/svskaushik/svskaushik@main/Assets/3fi.JPG",
    name: "Web3 Music: 3fi",
    ext: "jsx/sol",
    lang: "js,solidity",
    git: "https://github.com/svskaushik/3-fi",
    live: "https://3fi.vercel.app/",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/svskaushik/svskaushik@main/Assets/metaverse.JPG",
    name: "Polygon NFT mart",
    ext: "jsx/sol",
    lang: "js,solidity",
    git: "https://github.com/svskaushik/NFT-Marketplace",
    live: "https://metaversemarket.vercel.app/",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/svskaushik/svskaushik@main/Assets/dapp.JPG",
    name: "Token Exchange",
    ext: "jsx/sol",
    lang: "js,solidity",
    git: "https://github.com/svskaushik/dapp-exchange-project",
    live: "https://dapp-exchange-project.vercel.app/",
  },
  {
  img: "https://cdn.jsdelivr.net/gh/svskaushik/Python-Apps@main/bitcoin-price/btc.gif",
  name: "Bitcoin Tracker",
  ext: "py",
  lang: "python",
  git: "https://github.com/svskaushik/Python-Apps/tree/main/bitcoin-price",
  live: "https://github.com/svskaushik/Python-Apps/tree/main/bitcoin-price",
},
  {
  img: "https://cdn.jsdelivr.net/gh/svskaushik/portfolio-parallax@main/img/portfolio-parallax.png",
  name: "Parallax Portfolio",
  ext: "jsx",
  lang: "js",
  git: "https://github.com/svskaushik/portfolio-parallax",
  live: "https://portfolio-parallax.vercel.app/",
},
  {
  img: "https://cdn.jsdelivr.net/gh/svskaushik/Python-Apps@main/face-mask/facemask.gif",
  name: "Facemask Detection",
  ext: "py",
  lang: "python",
  git: "https://github.com/svskaushik/Python-Apps/tree/main/face-mask",
  live: "https://github.com/svskaushik/Python-Apps/tree/main/face-mask",
},
  {
  img: "https://cdn.jsdelivr.net/gh/svskaushik/svskaushik@main/Assets/wechef.JPG",
  name: "WeChef NFT",
  ext: "jsx/sol",
  lang: "js,solidity",
  git: "https://github.com/svskaushik/cheforama-marketplace",
  live: "https://cheforama-marketplace-svskaushik.vercel.app/",
  },
  {
  img: "https://cdn.jsdelivr.net/gh/svskaushik/Python-Apps@main/covid-stats/covidstats.png",
  name: "Covid Stats",
  ext: "py",
  lang: "python",
  git: "https://github.com/svskaushik/Python-Apps/tree/main/covid-stats",
  live: "https://github.com/svskaushik/Python-Apps/tree/main/covid-stats",
},
  {
  img: "https://cdn.jsdelivr.net/gh/svskaushik/Python-Apps@main/Voice-Recognition%20AI/voice-ai.gif",
  name: "Voice Assistant",
  ext: "py",
  lang: "python",
  git: "https://github.com/svskaushik/Python-Apps/tree/main/Voice-Recognition%20AI",
  live: "https://github.com/svskaushik/Python-Apps/tree/main/Voice-Recognition%20AI",
},

];